import { FC, ReactNode } from "react";

const Card: FC<{
    children?: ReactNode
    className?: string,
}> = ({ children = <></>, className }) => {
    return <div className={`w-full rounded-md bg-background dark:bg-dark-dark-background transition-all duration-300 shadow-sm   ${className}`}>
        {children}
    </div>
}


export default Card;